import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable } from "rxjs";
import { USER_URL } from "../shared/src";
import { ErrorHandlerService } from "./error-handler.service";

@Injectable({
    providedIn: 'root',
})

export class DashboardService {
    private readonly DASHBOARD_API = `${USER_URL}`;
    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    public getUserCountDetails(): Observable<any> {
        return this.http
            .get<any>(
                `${this.DASHBOARD_API}/dashboard/getAll`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getSurveyData(): Observable<any> {
        return this.http
            .get<any>(
                `${this.DASHBOARD_API}/dashboard/getAllSurvey`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getFilterData(): Observable<any> {
        return this.http
            .get<any>(
                `${this.DASHBOARD_API}/dashboard/getFilterData`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllProducts(): Observable<any> {
        return this.http
            .get<any>(
                `${this.DASHBOARD_API}/dashboard/getAllAllProducts`)
            .pipe(catchError(this.errorHandler.handleError));
    }
}